var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('our-story',{attrs:{"about":_vm.aboutDate.about}}),_c('achievements',{attrs:{"achievements":_vm.aboutDate.achievements}}),(_vm.aboutDate.teams.length > 0)?_c('our-team',{attrs:{"team":_vm.aboutDate.teams}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }